/**
 * Helpers for "load more" lists built from paginated API collections.
 */

/**
 * Page 1 replaces the list (new search, reset, or refetch after a change);
 * later pages append, de-duplicated so a refetch cannot double a row.
 */
export const mergePage = <T extends { id: string }>(
  prev: T[],
  results: T[],
  page: number
): T[] => {
  if (page === 1) return results;
  const known = new Set(prev.map((row) => row.id));
  return [...prev, ...results.filter((row) => !known.has(row.id))];
};

/**
 * More pages exist while fewer rows than the total are loaded. A page that
 * comes back short is the last one, whatever the total says, so an
 * auto-load can never loop.
 */
export const hasMorePages = ({
  loaded,
  total,
  lastPageSize,
  pageSize,
}: {
  loaded: number;
  total: number;
  lastPageSize: number;
  pageSize: number;
}): boolean => lastPageSize >= pageSize && loaded < total;
